import React, {useState, useRef, useEffect }from "react";
import useScrollToHash from "../../../components/hooks/useScrollToHash";
import ReadMore from "../../../components/common/read-more";

const AdmissionAndEnrollmentReadmore = () => {

  useScrollToHash(50);

  // const styles = {
  //   impactBanner: (bgcolor) => ({
  //     background: bgcolor,
  //     padding: "30px 30px",
  //     borderRadius: "30px",
  //     textAlign: "center",
  //     margin: "15px 0",
  //   }),
  //   ul: {
  //     listStyle: "none",
  //     padding: "0",
  //     display: "grid",
  //     gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  //     gap: "20px",
  //     margin: "30px 0",
  //   },
  //   li: {
  //     // background: bgcolor,
  //     padding: "20px",
  //     borderRadius: "12px",
  //     borderBottom: "3px solid #0984e3",
  //     fontSize: "1rem",
  //   },
  //   phaseCard: (color, bgColor) => ({
  //     borderLeft: `8px solid ${color}`,
  //     background: bgColor,
  //     padding: "10px 40px",
  //     borderRadius: "16px",
  //     marginBottom: "30px",
  //     boxShadow: "0 10px 25px rgba(0,0,0,0.03)",
  //     position: "relative",
  //   }),
  // };
  return (
    <div className="read-more-container">
      <div className="menu-container">
        {/* --- HERO SECTION --- */}
        <div className="ps-rm-section-card" id="Revolutionize">
          <div
            className="enrollment-image-card"
          >
            <img
              src="../images/product&soluction/read-more/admisionReadmore1.jpg"
              alt="Admissions"
              className="revolutionize-img"
              //   className="ps-rm-image"
            />
          </div>
          <h1 className="ps-rm-h1" style={{marginTop: "10px"}}>
            Revolutionize Your K-12 School's Admissions and Enrollment with
            Cutting-Edge Software
          </h1>
          <ReadMore maxHeight="80px">
            <p className="ps-rm-text">
              In today's fast-paced educational landscape, K-12 schools—whether
              private or public, online or onsite—face mounting pressures to
              streamline operations, enhance family experiences, and boost
              enrollment numbers. Enter advanced admissions and enrollment
              software: a game-changing solution designed to automate, simplify,
              and optimize the entire process from inquiry to registration. This
              software isn't just a tool; it's a strategic partner that empowers
              administrators to focus on what matters most—educating the next
              generation—while delivering seamless, modern experiences for
              prospective families.
            </p>
            <p className="ps-rm-text">
              Whether you're managing a bustling public district with lottery
              systems and zoning requirements, a selective private academy
              emphasizing personalized admissions, a fully online program
              handling virtual interactions, or a traditional onsite campus
              scheduling in-person tours, tailored software solutions exist to
              meet your unique needs.
            </p>
          </ReadMore>
        </div>

        {/* --- WHY ESSENTIAL SECTION --- */}
        <div className="ps-rm-section-card">
          <div
            className="enrollment-image-card ps-rm-image-wrapper"
            id="why-admission"
          >
            <img
              src="../images/product&soluction/read-more/admisionReadmore2.jpg"
              alt="Benefits"
              className="ps-rm-image"
            />
          </div>
          <h2 className="ps-rm-h2">
            Why Admissions and Enrollment Software is Essential for Your Schools
          </h2>
          <p className="ps-rm-text">
            Traditional paper-based or manual processes are outdated,
            error-prone, and time-consuming. Families expect digital
            convenience, similar to online shopping or banking, while schools
            need data-driven insights to compete for students. Admissions and
            enrollment software addresses these by:
          </p>
          <ul className="ps-rm-list">
            <li
              style={{backgroundColor: "#eaf4ff" }}
               className="readmore-card-hover ps-rm-list-item"
            >
              <strong style={{ fontSize: "1rem" }}>
                Reducing Administrative Burden:
              </strong>
              Automate form submissions, document uploads, and fee payments,
              freeing up staff for higher-value tasks like student support.
            </li>

            <li
              style={{backgroundColor: "#f3edff" }}
              className="readmore-card-hover ps-rm-list-item"
            >
              <strong style={{ fontSize: "1rem" }}>
                Improving Family Engagement:
              </strong>
              Provide user-friendly portals where parents can track applications
              in real-time, schedule visits or interviews, and receive
              personalized communications.
            </li>

            <li
              style={{backgroundColor: "#e9fbf8" }}
              className="readmore-card-hover ps-rm-list-item"
            >
              <strong style={{ fontSize: "1rem" }}>
                Enhancing Data Security and Compliance:
              </strong>{" "}
              Ensure HIPAA, FERPA, and GDPR compliance with encrypted data
              storage and role-based access controls.
            </li>

            <li
              style={{backgroundColor: "#fae1dd" }}
                 className="readmore-card-hover ps-rm-list-item"
            >
              <strong style={{ fontSize: "1rem" }}>
                Boosting Enrollment Rates:
              </strong>
              Tools like automated reminders and analytics help convert
              inquiries into enrollments, potentially increasing yields by
              20–30% based on industry benchmarks.
            </li>

            <li
              style={{backgroundColor: "#eae4e9" }}
                 className="readmore-card-hover ps-rm-list-item"
            >
              <strong style={{ fontSize: "1rem" }}>Cost Savings:</strong>{" "}
              Eliminate printing, mailing, and manual data entry, with some
              systems reporting ROI within the first year.
            </li>

            <li
              style={{backgroundColor: "#fff6e5" }}
                  className="readmore-card-hover ps-rm-list-item"
            >
              <strong style={{ fontSize: "1rem" }}>
                Improving Decision-Making with Analytics:
              </strong>{" "}
              Gain real-time insights into application trends, conversion rates,
              and drop-offs through dashboards and reports, enabling
              institutions to make faster, data-driven enrollment and
              operational decisions.
            </li>
          </ul>

          <p className="ps-rm-text">
            For schools, this means handling large-scale registrations
            efficiently amid budget constraints. Private schools benefit from
            sophisticated financial aid modules. Online programs leverage
            virtual tools for global reach, while onsite schools integrate event
            management for campus events.
          </p>
        </div>

        {/* --- CORE FEATURES SECTION --- */}
        <div className="ps-rm-section-card">
          <div className="enrollment-image-card ps-rm-image-wrapper ">
            <img
              src="../images/product&soluction/read-more/admisionReadmore3.jpg"
              alt="Features"
              className="ps-rm-image"
            />
          </div>
          <h2 className="ps-rm-h2">
            Core Features of Top Admissions and Enrollment Software
          </h2>

          {
            <ReadMore
              multiChildrenView={true}
              maxHeight="1786px"
              collapsedContent={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <h3 className="ps-rm-h3">
                    Online Application and Inquiry Management:
                  </h3>
                  <h3 className="ps-rm-h3">
                    Document Collection and Verification:
                  </h3>
                  <h3 className="ps-rm-h3">Fee and Tuition Management:</h3>
                  <h3 className="ps-rm-h3">Scheduling and Event Management:</h3>
                  <h3 className="ps-rm-h3">Communication and Marketing Tools:</h3>
                  <h3 className="ps-rm-h3">Reporting and Analytics:</h3>
                  <h3 className="ps-rm-h3">Integration and Customization:</h3>
                </div>
              }
              expandedContent={
                <div className="features-grid">
                  <h3 className="ps-rm-h3">
                    Online Application and Inquiry Management:
                  </h3>
                  <p className="ps-rm-text">
                    Families submit applications via customizable online forms
                    that support mobile devices. Features include conditional
                    logic (e.g., show financial aid questions only if
                    applicable) and multi-language support for diverse
                    communities.
                  </p>
                  <p className="ps-rm-text">
                    For online schools: Integrate video submissions for essays
                    or virtual auditions. Public schools can use geolocation for
                    zoning verification, while private ones add essay prompts or
                    recommendation forms.
                  </p>
                  <p className="ps-rm-text">
                    Real-time dashboards allow admins to track inquiries, with
                    CRM-like tools for nurturing leads through email drips or
                    SMS notifications.
                  </p>

                  <h3 className="ps-rm-h3">
                    Document Collection and Verification:
                  </h3>
                  <p className="ps-rm-text">
                    Secure uploads for transcripts, birth certificates, and
                    immunization records. AI-powered verification scans
                    documents for authenticity, reducing fraud.
                  </p>
                  <p className="ps-rm-text">
                    Onsite schools: Link to in-person document drop-off
                    scheduling. Online schools: Fully digital with e-signatures
                    via integrations like DocuSign.
                  </p>
                  <p className="ps-rm-text">
                    Private schools often include financial aid calculators,
                    pulling data from FAFSA or custom forms
                  </p>

                  <h3 className="ps-rm-h3">Fee and Tuition Management:</h3>
                  <p className="ps-rm-text">
                    Automated payment processing for application fees, deposits,
                    and tuition installments. Supports credit cards, ACH, and
                    even cryptocurrency in some advanced systems.
                  </p>
                  <p className="ps-rm-text">
                    Public schools: Handle free or subsidized enrollments with
                    waiver options. Private schools: Advanced billing with
                    variable tuition based on family income, scholarships, or
                    sibling discounts
                  </p>
                  <p className="ps-rm-text">
                    Integration with accounting software like QuickBooks ensures
                    seamless financial tracking.
                  </p>

                  <h3 className="ps-rm-h3">Scheduling and Event Management:</h3>
                  <p className="ps-rm-text">
                    Calendar tools for booking tours, open houses, interviews,
                    or orientations. Automated confirmations and reminders via
                    email or app notifications.
                  </p>
                  <p className="ps-rm-text">
                    Onsite adaptations include integration with Google Maps for
                    directions or RFID check-ins at events. Online versions
                    support virtual meeting links via Zoom or Microsoft Teams
                    for remote information sessions.
                  </p>
                  <p className="ps-rm-text">
                    For public schools in districts with school choice programs,
                    lottery scheduling ensures fair and transparent seat
                    assignments.
                  </p>

                  <h3 className="ps-rm-h3">Communication and Marketing Tools:</h3>
                  <p className="ps-rm-text">
                    Built-in email and SMS campaigns engage prospects with
                    personalized messaging based on application stage, such as
                    reminders to complete enrollment forms.
                  </p>
                  <p className="ps-rm-text">
                    Analytics track open rates and conversions, helping schools
                    refine marketing strategies. Social media integrations
                    enable targeted advertising on platforms like Facebook or
                    Instagram.
                  </p>
                  <p className="ps-rm-text">
                    Private schools can use drip campaigns to highlight unique
                    offerings such as STEM labs or arts curricula, while public
                    schools can promote district-wide initiatives like magnet
                    programs.
                  </p>

                  <h3 className="ps-rm-h3">Reporting and Analytics:</h3>
                  <p className="ps-rm-text">
                    Customizable reports provide insights into enrollment
                    trends, demographics, and yield rates. Predictive analytics
                    forecast future enrollments using historical data.
                  </p>
                  <p className="ps-rm-text">
                    Data can be exported to Excel or integrated with student
                    information systems such as PowerSchool or Infinite Campus
                    for streamlined reporting.
                  </p>
                  <p className="ps-rm-text">
                    Online schools can track global metrics including applicant
                    time zones and international enrollment surges.
                  </p>

                  <h3 className="ps-rm-h3">Integration and Customization:</h3>
                  <p className="ps-rm-text">
                    API connections integrate seamlessly with existing systems,
                    including learning management systems like Canvas for online
                    schools or transportation software for onsite public
                    districts.
                  </p>
                  <p className="ps-rm-text">
                    The platform scales across multi-campus networks and
                    supports role-based permissions for principals, counselors,
                    and IT staff.
                  </p>
                </div>
              }
            ></ReadMore>
          }
{/* 
          {readMoreTitleList && (
            <div className="features-grid">
              <h3 className="ps-rm-h3">
                Online Application and Inquiry Management:
              </h3>
              <p className="ps-rm-text">
                Families submit applications via customizable online forms that
                support mobile devices. Features include conditional logic
                (e.g., show financial aid questions only if applicable) and
                multi-language support for diverse communities.
              </p>
              <p className="ps-rm-text">
                For online schools: Integrate video submissions for essays or
                virtual auditions. Public schools can use geolocation for zoning
                verification, while private ones add essay prompts or
                recommendation forms.
              </p>
              <p className="ps-rm-text">
                Real-time dashboards allow admins to track inquiries, with
                CRM-like tools for nurturing leads through email drips or SMS
                notifications.
              </p>

              <h3 className="ps-rm-h3">Document Collection and Verification:</h3>
              <p className="ps-rm-text">
                Secure uploads for transcripts, birth certificates, and
                immunization records. AI-powered verification scans documents
                for authenticity, reducing fraud.
              </p>
              <p className="ps-rm-text">
                Onsite schools: Link to in-person document drop-off scheduling.
                Online schools: Fully digital with e-signatures via integrations
                like DocuSign.
              </p>
              <p className="ps-rm-text">
                Private schools often include financial aid calculators, pulling
                data from FAFSA or custom forms
              </p>

              <h3 className="ps-rm-h3">Fee and Tuition Management:</h3>
              <p className="ps-rm-text">
                Automated payment processing for application fees, deposits, and
                tuition installments. Supports credit cards, ACH, and even
                cryptocurrency in some advanced systems.
              </p>
              <p className="ps-rm-text">
                Public schools: Handle free or subsidized enrollments with
                waiver options. Private schools: Advanced billing with variable
                tuition based on family income, scholarships, or sibling
                discounts
              </p>
              <p className="ps-rm-text">
                Integration with accounting software like QuickBooks ensures
                seamless financial tracking.
              </p>

              <h3 className="ps-rm-h3">Scheduling and Event Management:</h3>
              <p className="ps-rm-text">
                Calendar tools for booking tours, open houses, interviews, or
                orientations. Automated confirmations and reminders via email or
                app notifications.
              </p>
              <p className="ps-rm-text">
                Onsite adaptations include integration with Google Maps for
                directions or RFID check-ins at events. Online versions support
                virtual meeting links via Zoom or Microsoft Teams for remote
                information sessions.
              </p>
              <p className="ps-rm-text">
                For public schools in districts with school choice programs,
                lottery scheduling ensures fair and transparent seat
                assignments.
              </p>

              <h3 className="ps-rm-h3">Communication and Marketing Tools:</h3>
              <p className="ps-rm-text">
                Built-in email and SMS campaigns engage prospects with
                personalized messaging based on application stage, such as
                reminders to complete enrollment forms.
              </p>
              <p className="ps-rm-text">
                Analytics track open rates and conversions, helping schools
                refine marketing strategies. Social media integrations enable
                targeted advertising on platforms like Facebook or Instagram.
              </p>
              <p className="ps-rm-text">
                Private schools can use drip campaigns to highlight unique
                offerings such as STEM labs or arts curricula, while public
                schools can promote district-wide initiatives like magnet
                programs.
              </p>

              <h3 className="ps-rm-h3">Reporting and Analytics:</h3>
              <p className="ps-rm-text">
                Customizable reports provide insights into enrollment trends,
                demographics, and yield rates. Predictive analytics forecast
                future enrollments using historical data.
              </p>
              <p className="ps-rm-text">
                Data can be exported to Excel or integrated with student
                information systems such as PowerSchool or Infinite Campus for
                streamlined reporting.
              </p>
              <p className="ps-rm-text">
                Online schools can track global metrics including applicant time
                zones and international enrollment surges.
              </p>

              <h3 className="ps-rm-h3">Integration and Customization:</h3>
              <p className="ps-rm-text">
                API connections integrate seamlessly with existing systems,
                including learning management systems like Canvas for online
                schools or transportation software for onsite public districts.
              </p>
              <p className="ps-rm-text">
                The platform scales across multi-campus networks and supports
                role-based permissions for principals, counselors, and IT staff.
              </p>
            </div>
          )} */}
        </div>

        {/* --- COMPARISON SECTION --- */}
        <div className="ps-rm-section-card">
          <h3 className="ps-rm-h3">
            Adaptations for Private vs. Public K–12 Schools:
          </h3>
          <div
           className="ps-rm-adaptation-wrapper"
          >
            <div
              style={{background: "#e1f5fe"}}
              className="readmore-card-hover-border ps-rm-adaptation-box"
            >
              <p className="ps-rm-text">
                <strong style={{ fontSize: "1rem" }}>Private Schools:</strong>{" "}
                Emphasis is placed on selectivity and revenue optimization.
                Admissions software from providers like Blackbaud or Enrollsy
                includes robust financial aid management, donor tracking for
                endowment-linked scholarships, and alumni records to support
                legacy admissions.
              </p>
              <p className="ps-rm-text">
                Marketing tools highlight institutional prestige through
                customizable portals that showcase testimonials, signature
                programs, and measurable success metrics such as college
                placement rates.
              </p>
            </div>
            <div
            style={{background: "#f3e5f5"}}
              className="readmore-card-hover-border ps-rm-adaptation-box"
            >
              <p className="ps-rm-text">
                <strong style={{ fontSize: "1rem" }}>Public Schools:</strong>{" "}
                The focus shifts to accessibility, equity, and large-scale
                operations. Platforms such as SchoolMint or EnrollWise support
                district-wide enrollment, including open enrollment policies,
                sibling preferences, and integration with state databases for
                free or reduced lunch eligibility.
              </p>
              <p className="ps-rm-text">
                These tools ensure transparency in lotteries and waitlists while
                maintaining compliance with public accountability and reporting
                standards.
              </p>
            </div>
          </div>
        </div>

        {/* --- SUCCESS STORIES --- */}
        <div className="ps-rm-section-card">
          <h3 className="ps-rm-h3">Real-World Success Stories and ROI:</h3>
          <ReadMore maxHeight="80px">
            <p className="ps-rm-text">
              Schools adopting modern enrollment systems report transformative
              results. Districts using SchoolMint have streamlined multi-site
              enrollment processes, reducing administrative processing time by
              up to 50 percent.
            </p>
            <p className="ps-rm-text">
              Private institutions leveraging platforms like Ravenna experience
              higher application volumes due to simplified and family-friendly
              workflows.
            </p>
            <p className="ps-rm-text">
              Users consistently praise intuitive interfaces and responsive
              customer support, with average ratings exceeding 4.5 out of 5
              across leading platforms.
            </p>
            <p className="ps-rm-text">
              Implementation is typically straightforward, with cloud-based
              deployments, minimal IT requirements, and flexible subscription
              pricing models that vary by provider.
            </p>
          </ReadMore>
        </div>

        {/* --- CALL TO ACTION --- */}
        <div style={{background: "#e1f5fe"}} className="ps-rm-impact">
          <h2>Ready to Elevate Your Enrollment?</h2>
          <p className="ps-rm-text">
            Don’t let outdated processes limit your school’s growth. Investing
            in modern admissions and enrollment software creates a more
            welcoming, efficient gateway for prospective families.
          </p>
          <p className="ps-rm-text">
            Schedule a demo with leading providers such as FACTS or Rediker to
            see how the right solution can transform your admissions experience
            and drive enrollment success.
          </p>
          <p
            className="ps-rm-text"
            style={{
              fontWeight: "bold",
              fontSize: "1.4rem",
            }}
          >
            Your students — and your bottom line — will thank you.
          </p>
        </div>
      </div>

      {/* <div style={styles.sectionDivider}>
        <div style={styles.dividerLine}></div>
        <div style={styles.dividerDot}></div>
      </div> */}

      <div className="menu-container">
        {/* --- HERO SECTION --- */}
        <div className="ps-rm-section-card" id="Dynamic">
          <div className="enrollment-image-card ps-rm-image-wrapper">
            <img
              src="../images/product&soluction/read-more/admisionReadmore4.jpg"
              alt="Dynamic School Website"
              className="ps-rm-image"
            />
          </div>
          <h1 className="ps-rm-h1">
            Launch Your Dynamic K–12 School Website in Just 90 Days: A
            Step-by-Step Guide for Building Online and Hybrid Schools
          </h1>

          <ReadMore maxHeight="110px">
            <p className="ps-rm-text">
              In the digital era, your K–12 school’s website is no longer just a
              static brochure—it’s the heartbeat of your community and a 24/7
              gateway for enrollment, engagement, and education. Whether you
              operate an onsite school fostering in-person connections or an
              online academy delivering virtual learning to students around the
              globe, a dynamic website can transform how you attract families,
              retain students, and streamline operations.
            </p>

            <p className="ps-rm-text">
              A dynamic website is interactive, content-rich, and easily
              updatable through a content management system (CMS). With the
              right strategy, schools can boost inquiries by up to 30 percent,
              improve parent satisfaction, and increase enrollment yields—all
              within a three-month timeline.
            </p>

            <p className="ps-rm-text">
              Why 90 days? This guide walks you through a proven process that
              takes schools from concept to launch efficiently, without the
              headaches of prolonged development cycles. Designed with a
              marketing-first mindset, it outlines an actionable roadmap for
              building a high-performing, SEO-optimized, and ADA-compliant
              website tailored to both online and onsite K–12 environments.
            </p>

            <p className="ps-rm-text">
              You’ll discover the key benefits of dynamic school websites, a
              step-by-step implementation plan, essential features, and
              customization options. Ready to elevate your school’s online
              presence and turn your website into a true enrollment engine?
              Let’s dive in and make your launch a success in just 90 days.
            </p>
          </ReadMore>
        </div>

        {/* --- INVESTMENT REASONING --- */}
        <div
          style={{borderLeftColor: "#0984e3", background: "#e1f5fe"}}
          className="readmore-card-hover ps-rm-phase-card"
        >
          <h3>Why Invest in a Dynamic K–12 School Website Now?</h3>
          <p className="ps-rm-text">
            Static websites are relics of the past. Dynamic school websites
            leverage CMS platforms or custom builds to enable real-time updates,
            personalized user experiences, and seamless integrations with tools
            such as learning management systems and productivity platforms.
          </p>
          <p className="ps-rm-text">
            For K–12 schools, a dynamic website supports enrollment growth,
            strengthens family engagement through interactive tools like virtual
            tours and event calendars, and ensures compliance with accessibility
            and data privacy standards. It also supports hybrid learning models
            by bridging onsite and online experiences in a single, cohesive
            platform.
          </p>
          <p className="ps-rm-text">
            With many modern tools available at low or no cost, the return on
            investment is fast—helping schools modernize operations, strengthen
            marketing, and stay competitive in a landscape where most families
            begin their school search online.
          </p>
        </div>

        <div className="ps-rm-section-card">
          <div className="enrollment-image-card ps-rm-image-wrapper">
            <img
              src="../images/product&soluction/read-more/admisionReadmore5.jpg"
              alt="Roadmap"
              className="ps-rm-image"
            />
          </div>
          {/* --- THE ROADMAP --- */}
          <h3 className="ps-rm-h3">
            The 90-Day Roadmap: Step-by-Step to a Dynamic Website
          </h3>
          <p className="ps-rm-text">
            This phased, budget-friendly roadmap breaks the process into three
            focused 30-day stages. By involving a small cross-functional
            team—typically administrators, IT staff, and marketing—you can move
            from planning to launch efficiently while maintaining quality and
            scalability.
          </p>

          <div className="ps-rm-phase-card" style={{borderLeftColor: "#6c5ce7", background: "#6c5ce72b"}}>
            <h3 className="ps-rm-h3">
              Phase 1: Days 1–30 – Planning and Discovery (Set the Foundation)
            </h3>
            <p className="ps-rm-text">
              <strong style={{ fontSize: "1.2rem" }}>
                Define Goals and Audience:
              </strong>{" "}
              Begin with a needs assessment. Onsite schools should focus on
              local families seeking campus culture and in-person experiences,
              while online schools should target global learners seeking
              flexibility. Surveys can help identify pain points such as
              simplified enrollment for public schools or virtual tours for
              private institutions.
            </p>
            <p className="ps-rm-text">
              <strong style={{ fontSize: "1.2rem" }}>
                Assemble Your Team:
              </strong>{" "}
              Form a committee of three to five key stakeholders, such as a
              principal, teacher, and parent representative. This group defines
              essential requirements like mobile responsiveness, multilingual
              support, and accessibility.
            </p>
            <p className="ps-rm-text">
              <strong style={{ fontSize: "1.2rem" }}>Choose a Platform:</strong>{" "}
              Select a content management system for flexibility and ease of
              updates or a specialized K–12 platform designed for education
              workflows. Test demos to evaluate usability and scalability.
            </p>
            <p className="ps-rm-text">
              <strong style={{ fontSize: "1.2rem" }}>
                Content Audit and Sitemap:
              </strong>{" "}
              Outline core pages including Home, About, Academics, and
              Admissions. Gather photos, videos, and testimonials. Online
              schools should prioritize interactive content, while onsite
              schools should highlight physical spaces and community culture.
            </p>
            <div className="ps-rm-milestone">
              Milestone: Approved wireframe and domain secured
            </div>
          </div>
          <div className="ps-rm-phase-card" style={{borderLeftColor: "#00cec9", background: "#00cec936"}}>
            <h3 className="ps-rm-h3">
              Phase 2: Days 31–60 – Design and Development (Build the Core)
            </h3>
            <p className="ps-rm-text">s
              <strong style={{ fontSize: "1.2rem" }}>
                Design for User Experience (UX/UI):
              </strong>{" "}
              Create clean, intuitive navigation with quick-access calls to
              action. Use responsive design to support mobile users, who often
              account for the majority of site traffic.
            </p>
            <p className="ps-rm-text">
              <strong style={{ fontSize: "1.2rem" }}>
                Incorporate Dynamic Features:
              </strong>{" "}
              Implement a CMS for easy content updates. Add calendars, blogs,
              and inquiry forms, and use rapid prototyping tools to accelerate
              development.
            </p>
            <p className="ps-rm-text">
              <strong style={{ fontSize: "1.2rem" }}>SEO Optimization:</strong>{" "}
              Target keywords such as “best online K–12 program” or “top onsite
              elementary school.” Optimize metadata, image alt text, and page
              speed to improve search visibility.
            </p>
            <p className="ps-rm-text">
              <strong style={{ fontSize: "1.2rem" }}>
                Accessibility Check:
              </strong>{" "}
              Ensure proper color contrast, screen reader compatibility,
              keyboard navigation, and compliance with accessibility standards.
            </p>
            <p className="ps-rm-text">
              <strong style={{ fontSize: "1.2rem" }}>Testing Round One:</strong>{" "}
              Conduct beta testing with staff and parents to gather feedback and
              resolve issues early.
            </p>
            <div className="ps-rm-milestone">
              Milestone: Functional prototype ready
            </div>
          </div>
          <div className= "ps-rm-phase-card" style={{borderLeftColor: "#0984e3", background: "#0984e342"}}>
            <h3 className="ps-rm-h3">
              Phase 3: Days 61–90 – Content, Launch, and Optimization (Go Live
              and Refine)
            </h3>
            <p className="ps-rm-text">
              <strong style={{ fontSize: "1.2rem" }}>Populate Content:</strong>{" "}
              Publish engaging academic overviews, staff bios, and event
              calendars. Onsite schools should highlight facilities, while
              online schools can embed previews of their learning platforms.
            </p>
            <p className="ps-rm-text">
              <strong style={{ fontSize: "1.2rem" }}>
                Integrations and Security:
              </strong>{" "}
              Connect student information systems or learning management
              systems, enable SSL certificates, and install analytics tools to
              monitor traffic and performance.
            </p>
            <p className="ps-rm-text">
              <strong style={{ fontSize: "1.2rem" }}>
                Final Testing and Training:
              </strong>{" "}
              Provide user training and conduct cross-browser and cross-device
              testing to ensure a smooth launch.
            </p>
            <p className="ps-rm-text">
              <strong style={{ fontSize: "1.2rem" }}>Launch Strategy:</strong>{" "}
              Announce the new website through email and social media campaigns.
              Monitor user behavior post-launch using heatmaps and analytics
              tools.
            </p>
            <p className="ps-rm-text">
              <strong style={{ fontSize: "1.2rem" }}>Optimization:</strong>{" "}
              Review performance metrics such as bounce rates and conversion
              rates. Optimize load times with a target of under three seconds.
            </p>
            <div className="ps-rm-milestone">
              Milestone: Live website & Marketing Tie-in
            </div>
          </div>
        </div>

        {/* --- FEATURES GRID --- */}
        <div
        className="ps-rm-section-card"
          style={{
            paddingBottom: "20px",
            paddingTop: "-30px",
          }}
        >
          <h3 className="ps-rm-h3">Key Features for a Dynamic K–12 Website</h3>
          <div className="ps-rm-list">
            <li
              style={{backgroundColor: "#eaf4ff" }}
                 className="readmore-card-hover ps-rm-list-item"
            >
              <strong style={{ fontSize: "1.05rem" }}>
                Interactive Elements:
              </strong>{" "}
              Virtual tours for onsite schools and live chat tools for online
              inquiries enhance engagement.
            </li>

            <li
              style={{backgroundColor: "#f3edff" }}
                  className="readmore-card-hover ps-rm-list-item"
            >
              <strong style={{ fontSize: "1.05rem" }}>
                Parent and Student Portals:
              </strong>{" "}
              Secure logins for grades, payments, and communications are
              essential for both onsite and online models.
            </li>

            <li
              style={{ backgroundColor: "#e9fbf8" }}
                 className="readmore-card-hover ps-rm-list-item"
            >
              <strong style={{ fontSize: "1.05rem" }}>
                Mobile Optimization:
              </strong>{" "}
              Fully responsive design ensures a seamless experience across all
              devices.
            </li>

            <li
              style={{backgroundColor: "#fae1dd" }}
                  className="readmore-card-hover ps-rm-list-item"
            >
              <strong style={{ fontSize: "1.05rem" }}>
                Multimedia Content:
              </strong>{" "}
              Videos, blogs, and image galleries bring school culture and
              achievements to life.
            </li>

            <li
              style={{backgroundColor: "#eae4e9" }}
                  className="readmore-card-hover ps-rm-list-item"
            >
              <strong style={{ fontSize: "1.05rem" }}>
                Security and Compliance:
              </strong>{" "}
              Encrypted forms, privacy notices, and cookie consent features
              protect user data and ensure compliance.
            </li>

            <li
              style={{backgroundColor: "#fff6e5" }}
                  className="readmore-card-hover ps-rm-list-item"
            >
              <strong style={{ fontSize: "1.05rem" }}>
                Performance & Accessibility:
              </strong>{" "}
              Fast-loading pages, accessibility-friendly design, and optimized
              assets ensure an inclusive and high-performing experience for all
              users.
            </li>
          </div>

          {/* --- ADAPTATIONS --- */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginTop: "40px",
              flexWrap: "wrap",
              marginBottom: "-20px",
            }}
          >
            <div
              style={{
                flex: 1,
                minWidth: "300px",
                background: "#ade8f4",
                padding: "30px",
                borderRadius: "15px",
              }}
              className="readmore-card-hover-border"
            >
              <strong style={{ fontSize: "1.05rem" }}>
                For Online Schools:
              </strong>
              Emphasize virtual-first design with asynchronous resources, video
              conferencing integrations, global accessibility, and search
              optimization for virtual education programs.
            </div>
            <div
              style={{
                flex: 1,
                minWidth: "300px",
                background: "#ade8f4",
                padding: "30px",
                borderRadius: "15px",
              }}
              className="readmore-card-hover-border"
            >
              <strong style={{ fontSize: "1.05rem" }}>
                For Onsite Schools:
              </strong>{" "}
              Highlight physical appeal through campus maps, photo galleries,
              event RSVPs, transportation information, and strong local SEO
              focused on community engagement.
            </div>
          </div>

          {/* --- FINAL CTA --- */}
          <div className="ps-rm-cta ">
            <h3 style={{ marginTop: 0 }}>Real Results and Next Steps</h3>
            <p style={{}}>
              Schools following similar 90-day website plans report traffic
              increases of 20 to 50 percent, along with stronger engagement and
              improved enrollment performance.
            </p>
            <p style={{ fontSize: "1.4rem", fontWeight: "bold" }}>
              Don’t delay your digital transformation. Start your 90-day journey
              today and turn your website into a powerful marketing and
              engagement engine for your school community.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmissionAndEnrollmentReadmore;
